import React, { useRef } from 'react';
import { AiFillCaretRight, AiFillCaretLeft } from "react-icons/ai";
import './style.scss';
import PropTypes from 'prop-types';


const HorizontalScroll = ({ children, maxVisibleItems = 5, enableButton }) => {
  const scrollRef = useRef();

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -scrollRef.current.offsetWidth,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: scrollRef.current.offsetWidth,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      {/* Left Button */}
      {enableButton && (
        <button
          className={'itemScrollButtonLeftDesign'}
          onClick={scrollLeft}
        >
          <AiFillCaretLeft />
        </button>
      )}
      {/* Scrollable Content */}
      <div
        ref={scrollRef}
        className={'itemScrollDesign'}
      >
        {React.Children.map(children, (child, index) => (
          <div
            key={index}
            style={{
              flex: `0 0 ${100 / maxVisibleItems}%`,
              scrollSnapAlign: "start",
            }}
          >
            {child}
          </div>
        ))}
      </div>

      {/* Right Button */}
      {enableButton && (
        <button
        className={'itemScrollButtonRightDesign'}
          onClick={scrollRight}
        >
          <AiFillCaretRight />
        </button>
      )}
    </div>
  );
};
HorizontalScroll.propTypes = {
  children: PropTypes.node.isRequired,
  maxVisibleItems: PropTypes.number,
  enableButton: PropTypes.bool
};

export default HorizontalScroll;



